import React from 'react';
import { graphql } from 'gatsby';

import PostsPage from '../components/posts-page';

export const query = graphql`
query($pageID: String!) {
  postsPage(id: { eq: $pageID }) {
    title
    category {
      name
      path
    }
    tags {
      name
      path
    }
    created(formatString: "MMMM DD, YYYY")
    updated(fromNow: true)
    body
    excerpt
    language
    isInternationalized
    path
  }
}
`;

const PostsPageTemplate = ({ data }) => {
  return <PostsPage page={data.postsPage} />;
};

export default PostsPageTemplate;
